import { render } from "./ManageBookings.vue?vue&type=template&id=2fcc5ba8&scoped=true"
import script from "./ManageBookings.vue?vue&type=script&lang=js"
export * from "./ManageBookings.vue?vue&type=script&lang=js"

import "./ManageBookings.vue?vue&type=style&index=0&id=2fcc5ba8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcc5ba8"]])

export default __exports__